// * This component takes in two different carousels and sets them up to be displayed based on device useragent
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import { FormattedMessage } from 'gatsby-plugin-react-intl';

import RichText from '../../Core/RichText';
import Stepper, { Step } from '../Stepper';
import MobileCarouselBanner from '../Banners/MobileCarouselBanner';
import DesktopCarouselBanner from '../Banners/DesktopCarouselBanner';
import Ctas from '../../Core/Ctas';

import { Wrapper, Title, Subtitle, StyledContainer } from './styles';

const mobile = 0;
const web = 1;

const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
    return web;
  }
  if (/android/i.test(userAgent)) {
    return mobile;
  }
  if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return mobile;
  }
  return web;
};

const ProductDeviceStep = ({ data }) => {
  if (!data) return null;
  const { sectionContainerHeading, sectionSubheading, elements, ctas } = data;
  const [OS, setOS] = useState(web);
  useEffect(() => {
    setOS(getMobileOperatingSystem());
  }, []);

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Title>{children}</Title>,
      [BLOCKS.HEADING_2]: (_, children) => <Title>{children}</Title>,
    },
  };

  return (
    <Wrapper>
      <StyledContainer>
        {sectionContainerHeading && (
          <RichText document={sectionContainerHeading} options={header} />
        )}
        {sectionSubheading && (
          <Subtitle>
            <RichText document={sectionSubheading} />
          </Subtitle>
        )}
        <Stepper
          className="product-device-step"
          start={OS}
          showStepper={OS === web}
        >
          {elements.map(stepper => {
            const featuredDevice = stepper.component.includes('desktop') ? (
              <FormattedMessage key={`desktop-${stepper.id}`} id="desktop" />
            ) : (
              <FormattedMessage key={`mobile-${stepper.id}`} id="mobile" />
            );
            return (
              <Step key={stepper.id} title={featuredDevice}>
                {stepper.component.includes('desktop') ? (
                  <DesktopCarouselBanner data={stepper} />
                ) : (
                  <MobileCarouselBanner
                    data={stepper}
                    showScreenNumber={false}
                  />
                )}
              </Step>
            );
          })}
        </Stepper>
        {ctas && <Ctas ctas={ctas} alignment="center" />}
      </StyledContainer>
    </Wrapper>
  );
};

ProductDeviceStep.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ProductDeviceStep;
